import CheckoutConfig from '@/shared/models/CheckoutConfig'
import { dateFromServer } from '../utils/format'

export default class Person {
  firstName?: string

  surname?: string

  birthDate?: string

  taxId?: string

  taxIdType?: string

  type?: 'NATURAL_PERSON' | 'COMPANY'

  email?: string

  phoneCountry?: number

  phoneArea?: number

  phone?: string

  disableDob?: boolean

  lockEmail?: boolean

  constructor(config: CheckoutConfig) {
    this.firstName = config.personFirstName
    this.surname = config.personSurname
    this.birthDate = dateFromServer(config.personBirth ?? '')
    this.taxId = config.personTaxId
    this.taxIdType = config.personTaxIdType?.toUpperCase()
    this.email = config.personEmail
    this.phoneCountry = config.personPhoneCountry
    this.phoneArea = config.personPhoneArea
    this.phone = config.personPhone
    this.disableDob = config.disableDob
    this.lockEmail = config.lockEmail
  }
}
